module.exports = __webpack_public_path__ + "img/40_38_030_700.89bc254e.jpg";